<template>
  <v-btn
    class="global-background-audio"
    ref="globalBackgroundAudio"
    :data-play="isPlay ? 1 : 0"
    @btnClick="on_play_and_pause"
  >
    <v-icon v-if="isPlay">volume_up</v-icon>
    <v-icon v-else>volume_off</v-icon>
  </v-btn>
</template>

<script>
import vAudio from "@/vendor/v-audio.min";
import { mp3Link } from "@/components/global-background-audio/helper";
import { uuidv4 } from "utils/util";

export default {
  data() {
    this.VAudioObject = null;
    this.playerId = uuidv4();
    this.audioLink = "";
    return {
      isPlay: false,
    };
  },
  mounted() {
    this.init_audio();
    this.$P.$on("pause-all-audio", this.pause);
  },
  watch: {
    $route: "change_audio",
  },
  methods: {
    pause(playerId) {
      if (playerId === this.playerId) return;
      this.VAudioObject?.pause?.();
    },
    init_audio() {
      this.VAudioObject = new vAudio({
        src: this.get_audio_link(),
        autoplay: false,
      });

      this.VAudioObject.on("play", () => {
        this.$P.$emit("pause-all-audio", this.playerId);
        this.isPlay = true;
      })
        .on("pause", () => {
          this.isPlay = false;
        })
        .on("ended", () => {
          this.VAudioObject.set_current_time(0);
          this.VAudioObject.play();
        });
    },
    get_audio_link() {
      return mp3Link[this.$route.path.split("/")[1]];
    },
    on_play_and_pause() {
      this.VAudioObject?.toggle_play?.();
    },
    /**
     * 切换当前音频链接
     */
    async change_audio() {
      let link = this.get_audio_link();
      //  如果音频一致时,跳出
      if (this.audioLink === link) {
        return;
      } else {
        this.audioLink = link;
      }

      this.VAudioObject.load_audio(link, this.isPlay);
    },
  },
};
</script>

<style lang="scss">
.global-background-audio {
  text-align: center;
  border-radius: 50%;

  i {
    line-height: 48px;
    font-size: 20px;
    @media (max-width: $lx-max) {
      line-height: 42px;
    }
  }
}
@media (max-width: $lx-max) {
  .global-background-audio {
    i {
      line-height: 42px;
    }
  }
}
</style>
